import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { times, get, noop, last, orderBy } from 'lodash-es';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';
import {
  EditorialEntities,
  buildAuthorArticlesPath,
  buildAuthorVideosPath,
  buildTypeArticlesPath,
  EditorialModel,
} from 'client/data/models/editorial';
import { ArticleCard } from './article-card';

const PLACEHOLDER_CARDS_NUM = 5;

export function ArticlesCardsPageUI({
  articles = [],
  videos = [],
  authorName = '',
  hideCategory = false,
  typeNews = false,
  type = '',
  openVideoModal = noop,
  hasAuthorLink = true,
  isMobile = false,
}) {
  const combinedCards = orderBy(
    [...articles, ...videos.map(video => ({ ...video, videoId: video.url ? last(video.url.split('/')) : '' }))].map(
      article => ({ ...article, date: article.updateDate || article.publishDate })
    ),
    ['date'],
    ['desc']
  );
  const articlesToRender = !combinedCards.length
    ? times(PLACEHOLDER_CARDS_NUM, ind => ({ ind: ind + 1, isPlaceholder: true }))
    : combinedCards;

  return (
    <Fragment>
      {articlesToRender.map(article => (
        <ArticleCard
          key={article.ind || article.relativeUrl || article.url}
          authorName={authorName || get(article, ['authors', 0, 'name'], '')}
          isMobile={isMobile}
          article={article}
          hideCategory={hideCategory}
          typeNews={typeNews}
          type={type}
          openVideoModal={openVideoModal}
          hasAuthorLink={hasAuthorLink}
        />
      ))}
    </Fragment>
  );
}

ArticlesCardsPageUI.propTypes = {
  articles: EditorialEntities.Articles,
  videos: EditorialEntities.Videos,
  authorName: PropTypes.string,
  hideCategory: PropTypes.bool,
  typeNews: PropTypes.bool,
  type: PropTypes.string,
  openVideoModal: PropTypes.func,
  hasAuthorLink: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export const AuthorArticlesPage = connectToModel(ArticlesCardsPageUI, {
  articles: bindToPath(
    ({ pageNum, author }) => buildAuthorArticlesPath(author, pageNum),
    EditorialModel,
    data => get(data, 'results', [])
  ),
  videos: bindToPath(
    ({ pageNum, author }) => buildAuthorVideosPath(author, pageNum),
    EditorialModel,
    data => get(data, 'results', [])
  ),
});

export const typeArticlesStateToPropsConfig = {
  articles: bindToPath(
    ({ pageNum, type }) => buildTypeArticlesPath(type, pageNum),
    EditorialModel,
    data => get(data, 'results', [])
  ),
};

export const TypeArticlesPage = connectToModel(ArticlesCardsPageUI, typeArticlesStateToPropsConfig);
